import client from './apiConnector';

async function getCategories() {
  return client().get('/categories');
}

export default {
  getCategories,
};
